import Cookies from 'browser-cookies';

// Reexport
const CookieService = Cookies;

export default CookieService;
